import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly10C2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10C/IMG_8365.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10C/IMG_8500.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10C/IMG_8510.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10C/IMG_8492.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10C/IMG_8494.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10C/IMG_8528.webp`;
  


  const photos = [
    { src: p1, source: p1, rows: 1, cols: 1 },
    { src: p2, source: p2, rows: 1, cols: 1 },
    { src: p3, source: p3, rows: 1, cols: 1 },
    { src: p4, source: p4, rows: 1, cols: 1 },
    { src: p5, source: p5, rows: 1, cols: 1 },
    { src: p6, source: p6, rows: 1, cols: 1 },
 
  ];

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                <Typography variant="h4" align="center">
                  Ayurveda: Aligning Body, Mind and Spirit
                </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  Class: 10C   Date: 13 and 15 JUNE 2026
                </Typography>

        <Typography variant={'subtitle1'} align={'justify'}>
        The students of Class 10 C presented their class assembly on the theme
        <strong> “Ayurveda: Aligning Body, Mind and Spirit.”</strong>
        The assembly highlighted the importance of Ayurveda and yogic practices 
        in maintaining harmony and overall well-being.
        <br></br>
        OThe first day began with a meaningful thought for the day, followed by a beautiful shloka and its explanation. The
        presentation emphasized how Ayurveda helps create balance in life by nurturing the body, calming the mind and
        uplifting the spirit. The students explained the relevance of Ayurvedic principles in today's fast-paced world and
        encouraged everyone to adopt healthy habits for a more balanced lifestyle.
        <br></br>
        The second day commenced with an inspiring thought and a brief introduction to the significance of Ayurveda. This
        was followed by an insightful and humorous skit in which students demonstrated various yogasanas and breathing
        techniques that benefit us in our daily lives. The skit showcased practices such as Balasana, Vrikshasana,
        Bhujangasana, and Bhramari Pranayama, highlighting their physical and mental health benefits in an engaging
        manner. The assembly concluded with a thoughtful message on the importance of incorporating Yoga and Ayurveda
        into our daily routines to lead healthier and happier lives.
        <br></br>
        The presentation was well received by the audience and inspired them to embrace the wisdom of Ayurveda and yoga
        for a balanced and fulfilling life.
        <br></br>
        </Typography>
              </Box>

            <Typography
                variant="h6"
                 color="primary"
                 align="center"
                 fontWeight="normal">
                <br />
              "When body, mind, and spirit are in harmony, true health blossoms — this is the essence of Ayurveda.”;
                 <br />
            </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 10C 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>

              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly10C2026;
